import { SET_MODULES_STATE } from '../constants/redux_types'

export const setModulesState = payload => {
  return {
    type: SET_MODULES_STATE,
    payload: payload
  }
}
